import DuiIconArrowLeft from './dui-icon-arrow-left/dui-icon-arrow-left.vue';
import DuiIconArrowRight from './dui-icon-arrow-right/dui-icon-arrow-right.vue';
import DuiIconArrowUp from './dui-icon-arrow-up/dui-icon-arrow-up.vue';
import DuiIconBalloon from './dui-icon-balloon/dui-icon-balloon.vue';
import DuiIconBalloonStroke from './dui-icon-balloon-stroke/dui-icon-balloon-stroke.vue';
import DuiIconBell from './dui-icon-bell/dui-icon-bell.vue';
import DuiIconBold from './dui-icon-bold/dui-icon-bold.vue';
import DuiIconBroadcast from './dui-icon-broadcast/dui-icon-broadcast.vue';
import DuiIconCalendar from './dui-icon-calendar/dui-icon-calendar.vue';
import DuiIconCamera from './dui-icon-camera/dui-icon-camera.vue';
import DuiIconCross from './dui-icon-cross/dui-icon-cross.vue';
import DuiIconDashboard from './dui-icon-dashboard/dui-icon-dashboard.vue';
import DuiIconDirectMail from './dui-icon-direct-mail/dui-icon-direct-mail.vue';
import DuiIconDiscover from './dui-icon-discover/dui-icon-discover.vue';
import DuiIconDollar from './dui-icon-dollar/dui-icon-dollar.vue';
import DuiIconDown from './dui-icon-down/dui-icon-down.vue';
import DuiIconEllipsis from './dui-icon-ellipsis/dui-icon-ellipsis.vue';
import DuiIconExpand from './dui-icon-expand/dui-icon-expand.vue';
import DuiIconEyeCrossed from './dui-icon-eye-crossed/dui-icon-eye-crossed.vue';
import DuiIconFacebook from './dui-icon-facebook/dui-icon-facebook.vue';
import DuiIconFeed from './dui-icon-feed/dui-icon-feed.vue';
import DuiIconFlag from './dui-icon-flag/dui-icon-flag.vue';
import DuiIconGlasses from './dui-icon-glasses/dui-icon-glasses.vue';
import DuiIconGoodreads from './dui-icon-goodreads/dui-icon-goodreads.vue';
import DuiIconGoogle from './dui-icon-google/dui-icon-google.vue';
import DuiIconHeart from './dui-icon-heart/dui-icon-heart.vue';
import DuiIconImage from './dui-icon-image/dui-icon-image.vue';
import DuiIconIndicator from './dui-icon-indicator/dui-icon-indicator.vue';
import DuiIconInfo from './dui-icon-info/dui-icon-info.vue';
import DuiIconItalic from './dui-icon-italic/dui-icon-italic.vue';
import DuiIconLeaderboard from './dui-icon-leaderboard/dui-icon-leaderboard.vue';
import DuiIconLeft from './dui-icon-left/dui-icon-left.vue';
import DuiIconLibrary from './dui-icon-library/dui-icon-library.vue';
import DuiIconLike from './dui-icon-like/dui-icon-like.vue';
import DuiIconLikeStroke from './dui-icon-like-stroke/dui-icon-like-stroke.vue';
import DuiIconLock from './dui-icon-lock/dui-icon-lock.vue';
import DuiIconLogo from './dui-icon-logo/dui-icon-logo.vue';
import DuiIconMenu from './dui-icon-menu/dui-icon-menu.vue';
import DuiIconMinus from './dui-icon-minus/dui-icon-minus.vue';
import DuiIconPlaceholder from './dui-icon-placeholder/dui-icon-placeholder.vue';
import DuiIconPlus from './dui-icon-plus/dui-icon-plus.vue';
import DuiIconPoll from './dui-icon-poll/dui-icon-poll.vue';
import DuiIconPower from './dui-icon-power/dui-icon-power.vue';
import DuiIconQuote from './dui-icon-quote/dui-icon-quote.vue';
import DuiIconRepost from './dui-icon-repost/dui-icon-repost.vue';
import DuiIconRight from './dui-icon-right/dui-icon-right.vue';
import DuiIconSaveLibrary from './dui-icon-save-library/dui-icon-save-library.vue';
import DuiIconSearch from './dui-icon-search/dui-icon-search.vue';
import DuiIconSearchFilters from './dui-icon-search-filters/dui-icon-search-filters.vue';
import DuiIconSettings from './dui-icon-settings/dui-icon-settings.vue';
import DuiIconShare from './dui-icon-share/dui-icon-share.vue';
import DuiIconStar from './dui-icon-star/dui-icon-star.vue';
import DuiIconSubmit from './dui-icon-submit/dui-icon-submit.vue';
import DuiIconTick from './dui-icon-tick/dui-icon-tick.vue';
import DuiIconTrash from './dui-icon-trash/dui-icon-trash.vue';
import DuiIconTriangle from './dui-icon-triangle/dui-icon-triangle.vue';
import DuiIconTwitter from './dui-icon-twitter/dui-icon-twitter.vue';
import DuiIconUnderline from './dui-icon-underline/dui-icon-underline.vue';
import DuiIconUpload from './dui-icon-upload/dui-icon-upload.vue';
import DuiIconVideo from './dui-icon-video/dui-icon-video.vue';
import DuiIconWarning from './dui-icon-warning/dui-icon-warning.vue';

import './dui-icon.scss';

export default {
  DuiIconArrowLeft: DuiIconArrowLeft,
  DuiIconArrowRight: DuiIconArrowRight,
  DuiIconArrowUp: DuiIconArrowUp,
  DuiIconBalloon: DuiIconBalloon,
  DuiIconBalloonStroke: DuiIconBalloonStroke,
  DuiIconBell: DuiIconBell,
  DuiIconBold: DuiIconBold,
  DuiIconBroadcast: DuiIconBroadcast,
  DuiIconCalendar: DuiIconCalendar,
  DuiIconCamera: DuiIconCamera,
  DuiIconCross: DuiIconCross,
  DuiIconDashboard: DuiIconDashboard,
  DuiIconDirectMail: DuiIconDirectMail,
  DuiIconDiscover: DuiIconDiscover,
  DuiIconDollar: DuiIconDollar,
  DuiIconDown: DuiIconDown,
  DuiIconEllipsis: DuiIconEllipsis,
  DuiIconExpand: DuiIconExpand,
  DuiIconEyeCrossed: DuiIconEyeCrossed,
  DuiIconFacebook: DuiIconFacebook,
  DuiIconFeed: DuiIconFeed,
  DuiIconFlag: DuiIconFlag,
  DuiIconGlasses: DuiIconGlasses,
  DuiIconGoodreads: DuiIconGoodreads,
  DuiIconGoogle: DuiIconGoogle,
  DuiIconHeart: DuiIconHeart,
  DuiIconImage: DuiIconImage,
  DuiIconIndicator: DuiIconIndicator,
  DuiIconInfo: DuiIconInfo,
  DuiIconItalic: DuiIconItalic,
  DuiIconLeaderboard: DuiIconLeaderboard,
  DuiIconLeft: DuiIconLeft,
  DuiIconLibrary: DuiIconLibrary,
  DuiIconLike: DuiIconLike,
  DuiIconLikeStroke: DuiIconLikeStroke,
  DuiIconLock: DuiIconLock,
  DuiIconLogo: DuiIconLogo,
  DuiIconMenu: DuiIconMenu,
  DuiIconMinus: DuiIconMinus,
  DuiIconPlaceholder: DuiIconPlaceholder,
  DuiIconPlus: DuiIconPlus,
  DuiIconPoll: DuiIconPoll,
  DuiIconPower: DuiIconPower,
  DuiIconQuote: DuiIconQuote,
  DuiIconRepost: DuiIconRepost,
  DuiIconRight: DuiIconRight,
  DuiIconSaveLibrary: DuiIconSaveLibrary,
  DuiIconSearchFilters: DuiIconSearchFilters,
  DuiIconSearch: DuiIconSearch,
  DuiIconSettings: DuiIconSettings,
  DuiIconShare: DuiIconShare,
  DuiIconStar: DuiIconStar,
  DuiIconSubmit: DuiIconSubmit,
  DuiIconTick: DuiIconTick,
  DuiIconTrash: DuiIconTrash,
  DuiIconTriangle: DuiIconTriangle,
  DuiIconTwitter: DuiIconTwitter,
  DuiIconUnderline: DuiIconUnderline,
  DuiIconUpload: DuiIconUpload,
  DuiIconVideo: DuiIconVideo,
  DuiIconWarning: DuiIconWarning,
};
